import { post } from '../service/request'

// 获取首页-智慧党建
export const getPartyBuilding = (page = 1, limit = 10) => {
	const params = {
		page,
		limit,
	}
	return post('/kxZhdj/getZhdjListAll', params)
}

// 获取首页-轮播图片
export const getCarousel = () => {
	const params = {
		parksCode: '001001',
		bannerId: 'main',
	}
	return post('/carouselImg/list', params)
}

// 获取首页园区动态
export const getParksDynamic = () => {
	const params = {
		parksCode: '001001',
		pageNum: 1,
		pageSize: 3,
	}
	return post('/kxParksDynamic/list', params)
}
